export default class TopicModel {
    constructor() {
        this.id = 0;
        this.topicName = "";
    }
}
